import i18n from '@/plugins/vue-i18n';
import { RouteRecordRaw } from 'vue-router';
import { Actions, Subjects } from '@boqnet/permissions';

const { t } = i18n.global;

export default [
  {
    path: '/:organisationId?/vendors',
    name: 'vendors',
    component: () => import('@/views/vendors/Vendors.vue'),
    meta: {
      title: t('routes.vendors.vendorsPageTitle'),
      layout: 'default',
      requiresAuth: true,
      action: Actions.LIST,
      subject: Subjects.ORG_VENDOR,
    },
  },
  {
    path: '/:organisationId?/vendors/create-custom-vendor',
    name: 'create-custom-vendor',
    component: () => import('@/views/vendors/CreateCustomVendor.vue'),
    meta: {
      title: t('routes.vendors.createCustomVendor'),
      layout: 'navigationOnly',
      requiresAuth: true,
      action: Actions.CREATE,
      subject: Subjects.ORG_VENDOR,
    },
  },
  {
    path: '/:organisationId?/vendors/:id/:name/:source/items',
    name: 'vendor-items',
    component: () => import('@/views/vendors/VendorItems.vue'),
    meta: {
      title: t('routes.vendors.vendorItemsPageTitle'),
      layout: 'default',
      requiresAuth: true,
      action: Actions.LIST,
      subject: Subjects.ORG_VENDOR_ITEM,
    },
  },
  {
    path: '/:organisationId?/vendors/:id/:name/:source/add-item',
    name: 'add-vendor-item',
    component: () => import('@/views/vendors/AddVendorItemViewResolver.vue'),
    meta: {
      title: t('routes.vendors.addVendorItem'),
      layout: 'navigationOnly',
      requiresAuth: true,
      action: Actions.CREATE,
      subject: Subjects.ORG_VENDOR_ITEM,
    },
  },
] as RouteRecordRaw[];
